/** `ez.t.update_deleted` — *When an update is deleted* (static recipe `7012`, 4 automations). */
import { z } from 'zod';
import { defineTrigger } from '../block.js';
export const updateDeletedParams = z.object({});
export const updateDeletedTrigger = defineTrigger({
    id: 'ez.t.update_deleted',
    kind: 'trigger',
    app: 'monday',
    sentencePartial: 'When an update is deleted',
    paramsSchema: updateDeletedParams,
    subscribes: ['update.deleted'],
    assumed: true,
    references: () => [],
    matches: () => true,
    outputs: (event) => ({ itemId: event.itemId, boardId: event.boardId, updateId: event.payload.updateId }),
});
//# sourceMappingURL=ez.t.update-deleted.js.map